import React from "react";

import { i18n } from "../../translate/i18n";

export default function ChatListSection({ label }) {
	if (!label) return null;
	return (
		<div className="mb-2 px-5 pt-1">
			<p className="mb-1 text-sm text-default-500">{label}</p>
		</div>
	);
}

export function getTailwickChatsHeaderTitle(tab) {
	const titles = {
		open: i18n.t("chat.layout.openSection"),
		pending: i18n.t("chat.layout.pendingSection"),
		closed: i18n.t("chat.layout.closedSection"),
		status: i18n.t("chat.layout.statusSection"),
	};
	return titles[tab] || i18n.t("chat.layout.openSection");
}

export function getTailwickListSections(tickets, status) {
	if (status === "open") {
		const recent = tickets.filter((t) => (t.unreadMessages || 0) > 0);
		const rest = tickets.filter((t) => !(t.unreadMessages || 0));
		return {
			primaryLabel:
				recent.length > 0
					? i18n.t("chat.layout.recentChats")
					: i18n.t("chat.layout.allConversations"),
			primaryTickets: recent.length > 0 ? recent : rest,
			secondaryLabel: recent.length > 0 ? i18n.t("chat.layout.allConversations") : null,
			secondaryTickets: recent.length > 0 ? rest : [],
		};
	}

	return {
		primaryLabel: null,
		primaryTickets: tickets,
		secondaryLabel: null,
		secondaryTickets: [],
	};
}
